export enum WhitelistType {
  FreeAccess = 0,
  Discount = 1,
  GateOnlyAccess = 2,
}
